import React from 'react';
import { Link } from 'react-router-dom';
import ArticleCard from '../components/ArticleCard';
import useNews from '../hooks/useNews';

function Trending({ articles }) {
  return (
    <aside className="trending-panel">
      <div className="section-heading"><span>Most Read</span></div>
      <ol>
        {articles
          .slice()
          .sort(
            (a, b) =>
              (b.viewCount || parseFloat(b.views)) -
              (a.viewCount || parseFloat(a.views))
          )
          .slice(0, 5)
          .map((article) => (
            <li key={article.id}>
              <Link to={`/article/${article.slug}`}>{article.title}</Link>
              <small>{article.category} · {article.views} views</small>
            </li>
          ))}
      </ol>
    </aside>
  );
}

function Home() {
  const { articles, loading, error } = useNews({ limit: 60 });
  const lead = articles[0];

  if (loading && !lead) {
    return (
      <div className="shell page-space">
        <p className="result-count">Retrieving the latest news…</p>
      </div>
    );
  }

  if (!lead) {
    return (
      <div className="shell page-space">
        <header className="page-header narrow">
          <span className="eyebrow">OPINIGURU</span>
          <h1>Newsroom update pending</h1>
          <p>
            {error ||
              'No published articles are currently available. An administrator can run the RSS import from the newsroom.'}
          </p>
        </header>
      </div>
    );
  }

  return (
    <div className="shell page-space">
      <section className="lead-grid">
        <article className="lead-story">
          <Link className="lead-image" to={`/article/${lead.slug}`}>
            <img src={lead.image} alt={lead.title} />
          </Link>
          <span className="eyebrow">{lead.label}</span>
          <h1><Link to={`/article/${lead.slug}`}>{lead.title}</Link></h1>
          <p>{lead.excerpt}</p>
          <div className="story-meta">
            <b>{lead.category}</b><i>•</i>{lead.date}<i>•</i>{lead.readTime}
          </div>
        </article>

        <div className="secondary-stories">
          <div className="section-heading">
            <span>Latest</span><Link to="/news">View all</Link>
          </div>
          {articles.slice(1, 4).map((article) => (
            <ArticleCard
              key={article.id}
              article={article}
              compact
              horizontal
            />
          ))}
        </div>
      </section>

      <div className="ad-slot">
        <span>ADVERTISEMENT</span><p>Premium top banner placement</p>
      </div>

      <section className="content-layout">
        <div>
          <div className="section-heading large">
            <span>Latest News</span><Link to="/news">All latest news →</Link>
          </div>
          <div className="news-grid">
            {articles.slice(4, 12).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
        <Trending articles={articles} />
      </section>

      <section className="opinion-strip">
        <div className="section-heading light">
          <span>Opinion & Analysis</span>
          <Link to="/news">Explore analysis →</Link>
        </div>
        <div className="opinion-grid">
          {articles
            .filter((article) => ['OPINION', 'ANALYSIS'].includes(article.label))
            .slice(0, 3)
            .map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
        </div>
      </section>

      <section>
        <div className="section-heading large">
          <span>Across Opiniguru</span>
        </div>
        <div className="wide-feed">
          {articles.slice(12, 22).map((article) => (
            <ArticleCard key={article.id} article={article} horizontal />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;